const translations = {
    clear: 'Clear',
    selectDate: 'Select date'
};

export default translations;
